export default "__VITE_ASSET__Dgt0dap6__"